import React from 'react';
import {Route, IndexRoute} from "react-router-dom";
import {HashRouter} from "react-router-dom"

import SocialScoreSettings from './components/SocialScoreSettings';

export default () => {
  return (
    <div className="cm-social-score-settings">
      <HashRouter>
        <Route path="/admin/v2/manageScoring" component={SocialScoreSettings} />
      </HashRouter>
    </div>
  );
}
